import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '@/store';
import router from '@/router';
import cookie from 'vue-cookie';

Vue.use(VueAxios, axios);

const API_URL = process.env.VUE_APP_API_URL;

let tokenJwt = null
if (localStorage.getItem('access_token') !== null) {
    tokenJwt = localStorage.getItem('access_token');
    // axios.defaults.headers.common['Authorization'] = tokenJwt
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenJwt;
} else if (sessionStorage.getItem('access_token') !== null) {
    tokenJwt = sessionStorage.getItem('access_token');
    // axios.defaults.headers.common['Authorization'] = tokenJwt
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenJwt;
}

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(callback) {
    refreshSubscribers.push(callback);
}

function onTokenRefreshed(newToken) {
    refreshSubscribers.forEach(callback => callback(newToken));
    refreshSubscribers = [];
}

Vue.axios.interceptors.response.use(
    (resp) => {
        return resp;
    },
    async (err) => {
        let originalRequest = err.config;
        let route = originalRequest.url.replace(originalRequest.baseURL, '');
        if (
            err.response &&
            err.response.status === 401 &&
            !originalRequest._retry &&
            route !== Vue.prototype.$apiRouter.refresh &&
            route !== Vue.prototype.$apiRouter.logout
        ) {
            originalRequest._retry = true;
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const resp = await Vue.axios.post(Vue.prototype.$apiRouter.refresh, {refresh_token: localStorage.getItem('refresh_token')});
                    localStorage.setItem('access_token', resp.data.data.access_token);
                    localStorage.setItem('refresh_token', resp.data.data.refresh_token);
                    sessionStorage.setItem('access_token', resp.data.data.access_token);
                    sessionStorage.setItem('refresh_token', resp.data.data.refresh_token);
                    originalRequest.headers['Authorization'] = 'Bearer ' + resp.data.data.access_token;
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.data.access_token;
                    onTokenRefreshed(resp.data.data.access_token);
                    isRefreshing = false;
                    return Vue.axios(originalRequest);
                } catch (refreshErr) {
                    isRefreshing = false;
                    return Promise.reject(refreshErr);
                }
            } else {
                return new Promise((resolve) => {
                    subscribeTokenRefresh((token) => {
                        originalRequest.headers['Authorization'] = 'Bearer ' + token;
                        resolve(Vue.axios(originalRequest));
                    });
                });
            }
        } else if (err.response && err.response.status === 401 && route === Vue.prototype.$apiRouter.refresh) {
            Vue.axios.post(Vue.prototype.$apiRouter.logout, {})
                .finally(() => {
                    cookie.delete(Vue.prototype.$cookieName, {domain: Vue.prototype.$cookieDomainName});
                    store.dispatch('removeUser');
                    store.dispatch('removeTokens');
                    router.push('/');
                    store.commit('setLoading', false);
                })
        } else {
            return Promise.reject(err);
        }
    }
);

